import { createStyles } from '@material-ui/core';

const styles = (theme) =>
  createStyles({
    successContainer: {
      maxWidth: 500,
      alignSelf: 'center',
      justifyContent: 'center',
      flex: 1,
      height: '100%',
      padding: 16,
    },
    successContent: {
      [theme.breakpoints.down('md')]: {
        marginTop: 'auto',
      },
      marginBottom: 24,
    },
    orderMail: {
      color: theme.palette.text.primary,
      textDecoration: 'underline',
    },
    orderId: {
      color: theme.palette.text.primary,
    },
    buttonsContainer: {
      gap: 8,
      [theme.breakpoints.down('md')]: {
        marginTop: 'auto',
      },
    },
  });

export default styles;
